import { AgreementCode } from 'Constants/agreementCodes.constants';

export interface DetailsCwp {
  agreementCode: AgreementCode;
  dates: CwpDates;
  coverages: ComparedCoverages;
  conditionCode: ComparedConditionCodes;
  price: ComparedPrices;
  documents: ComparedDocuments;
  status: ComparedStatus;
  hasFutureChanges: boolean;
  isCancelable: boolean;
  isInRenewal: boolean;
  policyNumber: string;
}

export enum StatusCwp {
  NONE = 'NONE',
  UNDER_ACTIVATION = 'SIK',
  HIDDEN_CASE = 'SAG',
  UNDER_CHANGE = 'SÆN',
  UNDER_CANCELATION = 'SIA',
  CANCELLED = 'AFG',
  IAK = 'IAK',
  ACTIVE = 'PRD',
  HST = 'HST',
  UNDER_RENEWAL = 'FNY',
}

export interface CwpDates {
  cancellationDate?: string;
  lastChangeDate?: string;
  originalIssueDate: string;
  renewalDateCwp: string;
  upcomingChangeDate?: string;
}

export interface ComparedConditionCodes {
  today: string;
  afterUpcomingChange?: string;
  afterLastChange?: string;
}

export interface ComparedCoverages {
  today: CwpCoverage[];
  afterUpcomingChange?: CwpCoverage[];
  afterLastChange?: CwpCoverage[];
}

export interface ComparedDocuments {
  today: CwpDocuments;
  afterUpcomingChange?: CwpDocuments;
  afterLastChange?: CwpDocuments;
}

export interface ComparedStatus {
  today: StatusCwp;
  afterUpcomingChange?: StatusCwp;
  afterLastChange?: StatusCwp;
}

export interface ComparedPrices {
  today: CwpPrice;
  afterUpcomingChange?: CwpPrice;
  afterLastChange?: CwpPrice;
}

export interface CwpDocuments {
  policyDocument?: CwpDocument;
  renewalDocument?: CwpDocument;
  allPolicyDocuments: CwpDocument[];
}

export interface CwpPrice {
  monthlyPrice: number;
  yearlyPrice: number;
  paymentTerm?: string;
}

export interface CwpDocument {
  documentHref: string;
  documentId: string;
  heading: string;
}

export interface CwpCoverage {
  coverageAmount: string;
  coverageProduct: string;
  ownContributionCode: string;
  ownContributionValue: string;
}
